var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-wrapper" },
    [
      _c("top_nav"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-container" },
        [
          _c(
            "transition",
            { attrs: { name: "fade-transform", mode: "out-in" } },
            [_c("keep-alive", [_c("router-view", { key: _vm.key })], 1)],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.key == "/index",
              expression: "key== '/index'"
            }
          ],
          staticClass: "tabBox"
        },
        [
          _c("div", { staticClass: "w" }, [
            _c("iframe", {
              ref: "myiframe",
              attrs: {
                name: "myiframe",
                id: "myiframe",
                src: _vm.query,
                frameborder: "0",
                width: "100%",
                height: 1850
              },
              on: {
                load: function($event) {
                  return _vm.oniframeload()
                }
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c("foot_nav")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-038e7047", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-038e7047","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/index.vue
// module id = null
// module chunks = 